<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="应用模块">
      <a-button slot="extra" type="primary" @click="handleNewApp">新增</a-button>
      <a-form layout="inline" :form="form">
       <a-form-model-item label="领域" >
                <a-select v-model="searchP.domain"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                        全部
                    </a-select-option>
                    <a-select-option value="001">
                        前台
                    </a-select-option>
                    <a-select-option value="002">
                        中台
                    </a-select-option>
                    <a-select-option value="003">
                        开放
                    </a-select-option>
                    <a-select-option value="004">
                        基础
                    </a-select-option>
             </a-select>
       </a-form-model-item>

          <a-form-item label="系统编码">
             <SysAutoComplete ref="syscodeAss" @onSysCodeChange="handleSearchSyscodeChange"></SysAutoComplete>
          </a-form-item>


         <a-form-item label="应用编码">
              <AppAutoComplete ref="appcodeAss" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
          </a-form-item>

          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"
                  @click="handleAppSearch"
              >查询</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
     </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
            <span>
            <router-link
                :to="{
                path:'detailapp',
                query: {
                    appcode: record.appcode,
                }
            }"
            >详情</router-link>
          </span>
          <span>
            <router-link
                :to="{
                path:'editapp',
                query: {
                    appcode: record.appcode,
                }
            }"
            >编辑</router-link>
          </span>
          <span>
            <a-popconfirm title="确认删除?" @confirm="() => onAppDelete(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
      <template slot="syscodet" slot-scope="text, record">
          <span>
            <router-link
                :to="{
                path:'/system/edit',
                query: {
                    syscode: record.syscode,
                }
            }"
            >{{text}}</router-link>
          </span>
      </template>
    </a-table>

    <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

   
    <!-- 新增编辑模态框 -->
 
  </div>
</template>
<script>
import AppAutoComplete from '@/components/AppAutoComplete'
import SysAutoComplete from '@/components/SysCodeAutoComplete'

let searchP = {
    appcode:'',
    syscode:'',
    total:0,
    pageSize:0,
    page:undefined,
    domain:''
}
const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '领域',
        dataIndex: 'domainname',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'domainname' },
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'syscodet' },
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'appcode' },
    },
    {
        title: '应用英文简称',
        dataIndex: 'appenname',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'appenname' },
    },
    {
        title: '应用中文简称',
        dataIndex: 'appname',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'appname' },
    },
    {
        title: '应用秘钥',
        dataIndex: 'appsecretkey',
        align: 'center',
        width:200,
    },
    {
        title: '开启线程池探测',
        dataIndex: 'thdetectflag',
        align: 'center',
        width:100,
        customRender:(text) => {
            return text == 'Y' ? '是' : '否'
        }
    },
    
    
    {
        title: '备注',
        dataIndex: 'remark',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'remark' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'operation' },
    },
];


const data = [];

export default {
    data() {
        // this.cacheData = data.map(item => ({ ...item }));
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            tLoading:true,
            searchP
        };
    },
    methods: {
        getAppList(){
            this.tLoading = true;
            let c_params = {
                ...this.searchP,
                flag:1,
                urlparams:false
            }
            this.$store.dispatch({
                type: "app/selectApp",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p){
            this.searchP.page = c_p;
            this.updateRoute();
        },
        updateRoute(){
            this.$router.push({
                query: {
                    ...this.searchP
                }
            });
        },
        handleAppSearch(){
            this.searchP.page = 1;
            this.updateRoute()
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.appcode = '';
            this.searchP.syscode = '';
            this.updateRoute();
        },
        handleNewApp(){
            this.$router.push({
                path: "addapp",
                query: {id:''}
            });
        },
        onAppDelete(key) {
            this.$store.dispatch({
                type: "app/deleteApp",
                params: {...key}
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getAppList();
                }
            });
        },
        handleSearchAppcodeChange(value){
            this.searchP.appcode = value;
        },
        handleSearchSyscodeChange(value){
            this.searchP.syscode = value;
        },
    },
    components:{
        AppAutoComplete,
        SysAutoComplete
    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    mounted(){
        let query = this.$route.query;
        this.searchP.appcode = query.appcode ? query.appcode : '';

        this.$refs.appcodeAss.setInputVal(this.searchP.appcode);

        this.searchP.syscode = query.syscode ? query.syscode : '';

        this.$refs.syscodeAss.setInputVal(this.searchP.syscode);
        this.getAppList();

        this.searchP.domain = searchP.domain ? searchP.domain : '';

        this.getAppList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
